import { PersonalData } from './personal-data';
import { Contacts } from './contacts';
import { DataGrid } from './client.styled';

export const ClientWrapper = (props) => {
  const { client, refreshClient } = props;

  return (
    <DataGrid>
      <PersonalData client={client} refresh={refreshClient} />
      <Contacts client={client} />
    </DataGrid>
  );
};
